// Imports
import Banner1 from "./1.png";
import Banner2 from "./2.png";
import Banner3 from "./3.png";
import Banner4 from "./4.png";
import Banner5 from "./5.png";
import Banner6 from "./6.png";
import Banner7 from "./7.png";
import Banner8 from "./8.png";
import Banner9 from "./9.png";
import Banner10 from "./10.png";
import Banner11 from "./11.png";
import Banner12 from "./12.png";
import Banner13 from "./13.png";
import Banner14 from "./14.png";
import Banner15 from "./15.png";
import Banner16 from "./16.png";
import Banner17 from "./17.png";
import Banner18 from "./18.png";
import Banner19 from "./19.png";
import Banner20 from "./20.png";
import Banner21 from "./21.png";
import Banner22 from "./22.png";
import Banner23 from "./23.png";
import Banner24 from "./24.png";
import Banner25 from "./25.png";
import Banner26 from "./26.png";
import Banner27 from "./27.png";
import Banner28 from "./28.png";
import Banner29 from "./29.png";
import Banner30 from "./30.png";
import Banner31 from "./31.png";
import Banner32 from "./32.png";
import Banner33 from "./33.png";
import Banner34 from "./34.png";
import Banner35 from "./35.png";
import Banner36 from "./36.png";
import Banner37 from "./37.png";
import Banner38 from "./38.png";
import Banner39 from "./39.png";
import Banner40 from "./40.png";
import Banner41 from "./41.png";
import Banner42 from "./42.png";
import Banner43 from "./43.png";
import Banner44 from "./44.png";
import Banner45 from "./45.png";
import Banner46 from "./46.png";
import Banner47 from "./47.png";
import Banner48 from "./48.png";
import Banner49 from "./49.png";
import Banner50 from "./50.png";
import Banner51 from "./51.png";
import Banner52 from "./52.png";
import Banner53 from "./53.png";
import Banner54 from "./54.png";
import Banner55 from "./55.png";
import Banner56 from "./56.png";
import Banner57 from "./57.png";
import Banner58 from "./58.png";
import Banner59 from "./59n.png";
import Banner60 from "./60.png";
import Banner61 from "./61.png";
import Banner62 from "./62.png";
import Banner63 from "./63.png";
import Banner64 from "./64.png";
import Banner65 from "./65.png";
import Banner66 from "./66.png";
import Banner67 from "./67.png";
import Banner68 from "./68.png";
import Banner69 from "./69.png";
import Banner70 from "./70.png";
import Banner71 from "./71.png";
import Banner72 from "./72.png";
import Banner73 from "./73.png";
import Banner74 from "./74.png";
import Banner75 from "./75.png";
import Banner76 from "./76.png";
import Banner77 from "./77.png";
import Banner78 from "./78.png";
import Banner79 from "./79.png";
import Banner80 from "./80.png";
import Banner81 from "./81.png";
import Banner82 from "./82.png";
import Banner83 from "./83.png";
import Banner84 from "./84.png";
import Banner85 from "./85.png";
import Banner86 from "./86.png";
import Banner87 from "./87.png";
import Banner88 from "./88.png";
import Banner89 from "./89.png";
import Banner90 from "./90.png";
import Banner91 from "./91.png";
import Banner92 from "./92.png";
import Banner93 from "./93.png";
import Banner94 from "./94.png";
import Banner95 from "./95.png";
import Banner96 from "./96.png";
import Banner97 from "./97.png";
import Banner98 from "./98.png";
import Banner99 from "./99.png";
import Banner100 from "./100.png";
import Banner101 from "./101.png";
import Banner102 from "./102.png";
import Banner103 from "./103.png";
import Banner104 from "./104.png";
import Banner105 from "./105.png";
import Banner106 from "./106.png";
import Banner107 from "./107.png";
import Banner108 from "./108.png";
import Banner109 from "./109.png";
import Banner110 from "./110.png";
import Banner111 from "./111.png";
import Banner112 from "./112.png";
import Banner113 from "./113.png";
import Banner114 from "./114.png";
import Banner115 from "./115.png";
import Banner116 from "./116.png";
import Banner117 from "./117.png";
import Banner118 from "./118.png";
import Banner119 from "./119.png";
import Banner120 from "./120.png";
export { default as Banner121 } from "./121.jpeg";
export { default as Banner122 } from "./122.png";
export { default as Banner123 } from "./123.jpeg";

// Export
export default {
  Banner1,
  Banner2,
  Banner3,
  Banner4,
  Banner5,
  Banner6,
  Banner7,
  Banner8,
  Banner9,
  Banner10,
  Banner11,
  Banner12,
  Banner13,
  Banner14,
  Banner15,
  Banner16,
  Banner17,
  Banner18,
  Banner19,
  Banner20,
  Banner21,
  Banner22,
  Banner23,
  Banner24,
  Banner25,
  Banner26,
  Banner27,
  Banner28,
  Banner29,
  Banner30,
  Banner31,
  Banner32,
  Banner33,
  Banner34,
  Banner35,
  Banner36,
  Banner37,
  Banner38,
  Banner39,
  Banner40,
  Banner41,
  Banner42,
  Banner43,
  Banner44,
  Banner45,
  Banner46,
  Banner47,
  Banner48,
  Banner49,
  Banner50,
  Banner51,
  Banner52,
  Banner53,
  Banner54,
  Banner55,
  Banner56,
  Banner57,
  Banner58,
  Banner59,
  Banner60,
  Banner61,
  Banner62,
  Banner63,
  Banner64,
  Banner65,
  Banner66,
  Banner67,
  Banner68,
  Banner69,
  Banner70,
  Banner71,
  Banner72,
  Banner73,
  Banner74,
  Banner75,
  Banner76,
  Banner77,
  Banner78,
  Banner79,
  Banner80,
  Banner81,
  Banner82,
  Banner83,
  Banner84,
  Banner85,
  Banner86,
  Banner87,
  Banner88,
  Banner89,
  Banner90,
  Banner91,
  Banner92,
  Banner93,
  Banner94,
  Banner95,
  Banner96,
  Banner97,
  Banner98,
  Banner99,
  Banner100,
  Banner101,
  Banner102,
  Banner103,
  Banner104,
  Banner105,
  Banner106,
  Banner107,
  Banner108,
  Banner109,
  Banner110,
  Banner111,
  Banner112,
  Banner113,
  Banner114,
  Banner115,
  Banner116,
  Banner117,
  Banner118,
  Banner119,
  Banner120,
};
